import $ from 'jquery';
import { initMobileMenu } from './mobile-menu';
import { paintMasonryLayout } from './masonry-layout';
import { initFancyInputBox } from './fancy-input';
import { initInfiniteScroll } from './infinite-scroll';
import { formValidationEvents } from './form/form-events';
import { initStateDropDownBox } from './state-dropdown';
import { sizePicker } from './offer-size-picker';
import { initCleaveDate } from './cleave-date';
//import { initTMIdentity } from './tm-login';

//import 'slick-carousel';
import 'slider-pro';

import {mobileMasker} from './mobile-masker';
import {autocomplete} from './autocomplete';

import { prepareMiniLightBox } from "./component/mini-lightbox/mini-lightbox-configure";


const initialViewportWidth = window.innerWidth;
const initialViewportHeight = window.innerHeight;
let resizeTimeout = null;

function onResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
			const newViewportWidth = window.innerWidth;
			const newViewportHeight = window.innerHeight;

			const widthChanged = Math.abs(newViewportWidth - initialViewportWidth) > 100;
			const heightChanged = Math.abs(newViewportHeight - initialViewportHeight) > 100;

        if (widthChanged || heightChanged) {
            location.reload();
        }
    }, 200); // Adjust the debounce delay as needed
}

window.addEventListener('resize', onResize);


$(function () {
	initMobileMenu();
	paintMasonryLayout();
	initFancyInputBox();
	initInfiniteScroll();
	initStateDropDownBox();
	formValidationEvents();
	sizePicker();
	//initTMIdentity();
	initCleaveDate();
	mobileMasker();
	autocomplete();
	prepareMiniLightBox();
});

if ( window.innerWidth >= 896 ) {
	$( '#sliderContent--main' ).sliderPro({
		//width: '100%',
		//height: '100%',
		//aspectRatio: 1,
		forceSize: 'fullWindow',
		arrows: true,
		buttons: false,
		waitForLayers: true,
		fade: false,
		autoplay: false,
		autoScaleLayers: true,
		reachVideoAction: 'playVideo',

	});
}

if  ( window.innerWidth < 896 ) {
	$( '#sliderContent--mobile' ).sliderPro({
		//width: '100%',
		//height: '100%',
		//aspectRatio: 1,
		forceSize: 'fullWindow',
		arrows: true,
		buttons: false,
		waitForLayers: true,
		fade: false,
		autoplay: false,
		autoScaleLayers: true,

	});
}
